@if (!isLastPage || isLoading) {
  <div class="load-more-btn" [@fadeState]="fadeState">
    @if (!isLastPage) {
      <button
        class="btn loading"
        [class.started]="isLoading"
        [disabled]="isLoading"
        (click)="onLoadMore()"
        type="button"
        >
        <span class="static">{{label}}</span>
        &ngsp;<span class="scale l">L</span>
        &ngsp;<span class="scale o">o</span>
        &ngsp;<span class="scale a">a</span>
        &ngsp;<span class="scale d">d</span>
        &ngsp;<span class="scale i">i</span>
        &ngsp;<span class="scale n">n</span>
        &ngsp;<span class="scale g">g</span>
      </button>
    }
    @if (isLoading) {
      <ut-loading-dots></ut-loading-dots>
    }
  </div>
}
